import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getWhatsappCampaigns } from "../api.ts";
import { whatsappCampaignKeys } from "./keys.ts";
import type {
  CampaignsQueryParams,
  PaginatedResponse,
  WhatsappCampaign,
} from "../../types.ts";

// Query hook for fetching WhatsApp campaigns list
export const useWhatsappCampaignsQuery = (
  params: CampaignsQueryParams | undefined,
) => {
  return useQuery<PaginatedResponse<WhatsappCampaign>>({
    queryKey: whatsappCampaignKeys.list(params),
    queryFn: async () => {
      const { data } = await getWhatsappCampaigns(
        params?.page,
        params?.perSize,
        params?.search,
      );
      return data;
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
};
